"use strict";

/**
 * Show video trailer inside thumbnail on hover (web) or on touch (mobile)
 */
;

var FlixTrailer = function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);
  var timeout = null;
  /**
   * Initialize event handlers.
   * Called in the end to let this module fully load in to the memory first.
   */

  function onPageLoad() {
    if (FlixUtils.isCrawler()) {
      return;
    }

    init(document);
  }

  ;
  /**
   * You can initialize it for whole document of for the specific part (if it was loaded by ajax)
   * 
   * @param {HTMLElement} node 
   */

  function init(node) {
    node.querySelectorAll('[data-trailer]').forEach(function (el) {
      el.addEventListener('mouseenter', start);
      el.addEventListener('touchstart', start);
      el.addEventListener('mouseleave', stop);
    });
  }
  /** 
   * @param {Event} e
   */


  function start(e) {
    stop();
    /** @type HTMLElement */

    var el = e.currentTarget;
    var url = el.getAttribute('data-trailer');

    if (url) {
      timeout = setTimeout(function () {
        // remove existing trailer players
        document.querySelectorAll('.trailer-player').forEach(function (cur) {
          return cur.remove();
        });
        el.insertAdjacentHTML("beforeend", '<video autoplay loop muted playsinline class="trailer-player" ' + 'style="position: absolute; top: 0; left:0; width:100%; overflow:hidden;">' + '<source src="' + url + '" type="video/mp4"></video>');
      }, 300);
    }
  }

  ;
  /** 
   * Do not use "this" here, since it's an event handler
   * 
   * @param {Event} e 
   */

  function stop(e) {
    // remove existing trailer players
    document.querySelectorAll('.trailer-player').forEach(function (cur) {
      return cur.remove();
    });

    if (typeof timeout !== 'undefined') {
      clearTimeout(timeout);
    }
  }

  ;
  return {
    init: init
  };
}();